import { render, staticRenderFns } from "./MordaLentaGifts.vue?vue&type=template&id=4ae4d266&scoped=true"
import script from "./MordaLentaGifts.vue?vue&type=script&lang=js"
export * from "./MordaLentaGifts.vue?vue&type=script&lang=js"
import style0 from "./MordaLentaGifts.vue?vue&type=style&index=0&id=4ae4d266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae4d266",
  null
  
)

export default component.exports